import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-view-boxes-fill",
  templateUrl: "./med-icon-view-boxes-fill.component.html",
})
export class MedIconViewBoxesFillComponent extends SvgMixinComponent {}
